import * as graphql from 'generated/graphql';
import _ from 'lodash';

export interface ISkillsAnalysis {
	jobTitle?: graphql.JobTitle;
	appraisals: graphql.CompetencyAppraisal[];
	competencies: graphql.Competency[];
	jobCompetencies: graphql.JobCompetency[];
}

export function isOwnedJobTitle(user: graphql.User, jobTitleID: string) {
	if (jobTitleID === 'all') {
		return true;
	}

	const { jobPositions } = user;
	const result = jobPositions.find((jobPosition) => {
		return jobPosition.jobTitle.id === jobTitleID;
	});

	return !!result;
}

export function skillsAnalysisFromUser(user: graphql.User, jobTitleID?: string): ISkillsAnalysis {
	const { jobPositions } = user;
	const jobCompetencies = jobPositions
		.filter((jobPosition) => {
			if (!jobTitleID || jobTitleID === 'all') {
				return true;
			}
			return jobPosition.jobTitle.id === jobTitleID;
		})
		.flatMap(({ competencies }) => competencies) as graphql.JobCompetency[];

	const appraisals = jobPositions.flatMap(
		({ appraisal }) => appraisal,
	) as graphql.CompetencyAppraisal[];

	const competencies = _.uniqBy(
		_.map(jobCompetencies, ({ competency }) => competency),
		'id',
	);

	return {
		appraisals,
		competencies,
		jobCompetencies,
		jobTitle: jobTitleID
			? jobPositions.find((jobPosition) => {
					return jobPosition.jobTitle.id === jobTitleID;
			  })?.jobTitle
			: undefined,
	};
}

export function skillsAnalysisFromJobTitle(jobTitle: graphql.JobTitle): ISkillsAnalysis {
	const jobCompetencies = jobTitle.competencies;
	const appraisals = jobTitle.appraisal;
	const competencies = _.uniqBy(
		_.map(jobCompetencies, ({ competency }) => competency),
		'id',
	);

	return { appraisals, competencies, jobCompetencies, jobTitle };
}
